<template>
  <transition name="dynamic-sidebar" @after-leave="hideActive">
    <div class="dynamic-sidebar" :class="this.area ? [`area-${this.area}`] : []" v-show="this.isFinalVisible">
      <div class="-ds-fake-remove" @click="hide"></div>
      <div class="-ds-slide">
        <span class="dynamic-button-close" @click="hide">
          <svg class="dynamic-button-close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </span>
        <div class="-ds-scroll">
          <div class="-ds-inner">
            <slot :hide="hide" :area="area"/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import smartToggle from "../../mixins/smartToggle";

export default {
  name: 'DynamicSidebar',

  mixins: [smartToggle],

  data() {
    return {
      area: null,
    };
  },

  methods: {
    show(area) {
      this.isVisible = true;
      this.area = area;
    },

    hide() {
      this.isVisible = false;
    },

    hideActive() {
      this.area = null;
    },
  },
}
</script>

<style scoped>
.dynamic-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .7);
  overflow: hidden;
  z-index: 200;
  transition: background .35s ease-out;
}

.-ds-fake-remove {
  content: '';
  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
}

.-ds-slide {
  position: absolute;
  z-index: 10;
  top: auto;
  left: 0;
  right: 0;
  bottom: 0;
  background: #181818;
  max-height: calc(100% - 48px);
  height: unset;
  width: 100%;
  border-radius: 6px 0 0 0;
  transition: transform .35s;
}

.-ds-scroll {
  max-height: calc(100vh - 48px);
  overflow-x: hidden;
  overflow-y: auto;
}

.-ds-inner {
  padding: 20px 20px calc(20px + (env(safe-area-inset-bottom) / 2));
}

.dynamic-sidebar-enter,
.dynamic-sidebar-leave-to {
  background: rgba(0, 0, 0, 0);
}

.dynamic-sidebar-enter .dynamic-button-close {
  opacity: 0;
  transition: opacity .35s linear .70s;
}

.dynamic-sidebar-leave-to .dynamic-button-close {
  opacity: 0;
}

.dynamic-button-close {
  position: absolute;
  z-index: 20;
  right: 0;
  top: -32px;
  left: auto;
  bottom: auto;
  width: 32px;
  height: 32px;
  opacity: 1;
  background: #181818;
  text-align: center;
  border-radius: 6px 6px 0 0;
  cursor: pointer;
}

.dynamic-button-close-icon {
  display: inline-block;
  vertical-align: top;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  width: 24px;
  height: 32px;
  color: #fff;
}

.dynamic-sidebar-enter .-ds-slide,
.dynamic-sidebar-leave-to .-ds-slide {
  transform: translateY(100%);
}

/* CUSTOM account-notifications AREA */
.dynamic-sidebar.area-account-notifications .-ds-inner {
  padding: 0;
}

@media (min-width: 768px) {
  .dynamic-sidebar {
    background: rgba(0, 0, 0, .8);
  }

  .-ds-slide {
    top: 0;
    left: auto;
    max-height: 100vh;
    height: 100vh;
    max-width: 375px;
    border-radius: 0;
  }

  .-ds-scroll {
    max-height: 100%;
    height: 100%;
  }

  .-ds-inner {
    display: grid;
    width: 100%;
    min-height: 100%;
  }

  .dynamic-button-close {
    right: auto;
    top: 0;
    left: -32px;
    border-radius: 6px 0 0 6px;
  }

  .dynamic-sidebar-enter .-ds-slide,
  .dynamic-sidebar-leave-to .-ds-slide {
    transform: translateX(100%);
  }

  /* CUSTOM account-notifications AREA */
  .dynamic-sidebar.area-account-notifications .-ds-slide {
    max-width: 490px;
  }
}
</style>
